import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_sheet = _resolveComponent("v-sheet")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_dialog, {
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
    "max-width": _ctx.maxWidth,
    persistent: _ctx.persistent,
    class: "mx-0 px-0",
    scrollable: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_sheet, {
        class: "config-card-overlay bg-background mx-0 px-0",
        color: "background",
        density: "compact",
        elevation: 0
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card_title, { class: "config-card-overlay__header" }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_ctx.title), 1),
              _createVNode(_component_v_spacer),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                onClick: _ctx.closeOverlay
              }, null, 8, ["onClick"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_card_text, { class: "config-card-overlay__body mx-0 px-0" }, {
            default: _withCtx(() => [
              _renderSlot(_ctx.$slots, "default", {}, undefined, true)
            ]),
            _: 3
          })
        ]),
        _: 3
      })
    ]),
    _: 3
  }, 8, ["model-value", "max-width", "persistent"]))
}